<template>
  <div class="cp-about-view">
    <div class="cp-about-view-breadcrumbs-container">
      <!-- <Breadcrumbs /> -->
    </div>
    <section class="section-one">
      <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-22_F0PaaawurqM3.jpg">
    </section>
    <!-- <img class="cp-about-view-logo" :src="company.logo_image" /> -->
    <section class="section-two md-center">
          <!-- <img src="https://ik.imagekit.io/osusf6xvdf/beta/section-2-bg_2gscKKk2OUk9.png"
          class="section-two-bg"> -->
        <div class="section-two-logo is-hidden-touch is-hidden-desktop">
          <!-- <img src="https://ik.imagekit.io/osusf6xvdf/beta/logo-secondary_m_QrdfROWV-F.png"
          width="150"
          height="70"> -->
        </div>
        <div class="section-two-content">
          <h2 class="section-two-content-title">Madam Ranee Herbal Soap</h2>
          <div class="">
              <span class="section-two-content-detail">
                Madam Ranee Herbal Soap follows the same recipe of centuries-long local wisdom
                of Thai herbs.The herbs are naturally extracted and<br>formulated
                into an aromatic premium-grade soap, gentle to the skin. Antibacterial
                properties in the soap help protect the skin from acne,<br>
                blackheads, and all blemishes as well as retain moisture for a healthy-looking skin.
              </span>
          </div>
        </div>
        <div class="section-two-icon columns is-mobile">
          <div class="column">
          </div>
          <div class="column is-3-mobile is-3-desktop is-4-tablets">
              <img src="https://ik.imagekit.io/osusf6xvdf/beta/section-2-icon-1_R7JioxtcOVaA.png"
              class="section-two-img">
              <p class="section-two-img-desc">Natural Extract</p>
          </div>
          <div class="column is-3-mobile is-3-desktop is-4-tablets">
              <img src="https://ik.imagekit.io/osusf6xvdf/beta/section-2-icon-2_NIk7sC3Sshf.png"
              class="section-two-img">
              <p class="section-two-img-desc">Whitening</p>
          </div>
          <div class="column is-3-mobile is-3-desktop is-4-tablets">
              <img src="https://ik.imagekit.io/osusf6xvdf/beta/section-2-icon-3_So3eLbZkQgg.png"
              class="section-two-img">
              <p class="section-two-img-desc">Safe</p>
          </div>
          <div class="column">
          </div>
        </div>
    </section>
    <!-- Section 3 -->
    <section class="section-three">
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-23_39YlCVPAl9i.png"
        class="section-3-bg is-hidden-touch"
        >
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/Madam_Ranee_Mobile_site_Export-13_b771x0zX3.png"
        class="section-3-bg is-hidden-desktop"
        >
      <div class="">
        <div class="columns">
          <div class="column text-horizon-center
           is-12-mobile is-6-desktop container has-text-left is-hidden-desktop">
            <h3 class="section-three-title">Madam Ranee Sripaiboon</h3>
            <hr class="section-three-hr"/>
            <p class="section-three-content">Our factory, based in Thailand,
              uses genuine<br>herbs without chemicals to serve an aromatic<br>
              premium-grade soap for 30 years.
            </p>
          </div>
          <div class="column section-three-img text-center pd-t-10 is-12-mobile is-6-desktop">
            <!-- <img src="https://ik.imagekit.io/osusf6xvdf/beta/section-3-img-1_2Js1u9JOjyAD.png"> -->
          </div>
        </div>
      </div>
    </section>
    <section class="section-four">
      <div class="md-img-section">
        <!-- <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-63_ur6b_yub_.png"
            class="md-img-section-main is-hidden-touch"> -->
        <!-- <img src="https://ik.imagekit.io/osusf6xvdf/beta/mobile-section-4-bg_ohphDYfSPS6.png"
            class="md-img-section-main is-hidden-desktop"> -->
        <div class="columns">
          <div class="column">
            <!-- <img
              src="https://ik.imagekit.io/osusf6xvdf/beta/section-4-img-1_mLd-Su7V3KJ.png"
              class="md-img-section-bottom-left"
            > -->
          </div>
          <div class="column">
            <img
              src="https://ik.imagekit.io/osusf6xvdf/beta/section-4-img-2_qZc-0OQXLfiG.png"
              class="md-img-section-top-right is-hidden-touch"
            >
          </div>
        </div>
      </div>
    </section>
    <section class="section-five container">
      <div class="columns">
        <div class="column section-five-img">
          <img
              src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-24_xGhZkDJToKe9.jpg"
              class="md-img-section-top-right"
            >
        </div>
        <div class="column section-five-img">
           <img
              src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-25__9v0Xh5Rs.jpg"
              class="md-img-section-top-right"
            >
        </div>
        <div class="column section-five-img">
           <img
              src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-26_eYO4rZftT-.jpg"
              class="md-img-section-top-right"
            >
        </div>
        <div class="column section-five-img">
           <img
              src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-27_4t-Se_Vnb.jpg"
              class="md-img-section-top-right"
            >
        </div>
      </div>
    </section>
    <!-- <div class="cp-about-view-container columns is-mobile is-multiline">
      <div
        class="cp-about-view-company-image-mobile column is-12-mobile is-hidden-tablet"
        :style="{
          backgroundImage: `url('${company.company_image}')`,
        }"
      />
      <div class=" column is-12-mobile is-hidden-mobile">
        <img class="cp-about-view-company-image" :src="company.company_image" />
      </div>
      <div class="column is-12-mobile">
        <div class="cp-about-view-company-name has-text-weight-bold has-text-link is-size-4">
          {{ company.company_name_localized }}
        </div>

        <Reader class="cp-product-detail-view-content" :content="company.content_localized" />
      </div>
    </div> -->
    <OrderFloatIcon />
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import Reader from '@/components/Quill/Reader.vue';
// import IconSet from '@/components/IconSet.vue';
// import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import OrderFloatIcon from '@/components/OrderFloatIcon.vue';

export default {
  name: 'AboutView',
  components: {
    OrderFloatIcon
    // Reader,
    // IconSet,
    // Breadcrumbs,
  },
  computed: mapState({
    company: state => state.company,
  }),
  watch: {
    company() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.cp-about-view{
  margin-bottom: 10%;
}
.pd-t-10{
  padding-top:10%;
}
.text-center{
  text-align: center;
}
.md-img-section{
  &-top-right{
    z-index: 0;
  }
  &-bottom-left{
    position: absolute;;
    bottom: -10%;
    height: 50%;
  }
  &-main{
    position: absolute;
    z-index: -1;
    padding-top: 15%;
  }
}
.section{
  &-one{
    position: relative;
    z-index: 1;
  }
  &-two{
    position: relative;
    z-index: 2;
    margin-bottom:20px;
     @media screen and (min-width: 900px) {
          // margin-top: -10%;
        }
    &-content{
      margin-top:15px;
      margin-bottom:3%;
      &-title{
        font-size: 150%;
        font-weight: 700;
        margin-bottom:20px;
        padding-top: 3%;
      }
      &-detail
      {
        margin-bottom:20px;
      }
    }
    &-bg{
        height: 100% !important;
        z-index: -1;
        right: 0%;
        width: 100%;
        margin-top: -25%;
        position: absolute;
         @media screen and (min-width: 900px) {
          margin-top: -5%;
        }
    }
    &-img{
      &-desc{
        font-size:20px;
        font-weight: 700;
        padding-top: 2%;
      }
    }
    &-logo{
      //  padding-top: -20%;
      img{
       width: 150px;
       height: auto;
       @media screen and (max-width: 900px) {
          width: 120px;
          height: auto;
        }
      }
    }
    &-icon{
      margin-bottom: 2%;
      @media screen and (max-width: 900px) {
          margin-bottom:30px;
        }
      img{
        // width:200px;
        height:120px;
        @media screen and (max-width: 900px) {
          width: 60px;
          height: auto;
        }
      }
    }
  }
  &-four{
    position: relative;
    z-index: -1;
    @media screen and (max-width: 900px) {
          padding-top:70%;
        }
  }
  &-five{
    text-align: -webkit-center;
     @media screen and (max-width: 900px) {
          margin-top:20%;
      }
      &-img{
        @media screen and (max-width: 900px) {
          width:80%;
          text-align: center;
        }
      }
  }
  &-three{
    position: relative;
    z-index: 1;
    margin-bottom: -13%;
    .text-horizon-center{
      padding-top:12%;
      padding-left: 5rem;
      padding-right: 5rem;
      @media screen and (max-width: 900px) {
          padding-top:10%;
          padding-left: 3rem;
          padding-right: 3rem;
        }
    }
    &-hr{
      border: 1px solid black;
    }
    &-title{
      font-weight: 700;
      font-size:250%;
      @media screen and (max-width: 900px) {
          font-weight: 700;
          font-size:130%;
        }
    }
    &-content{
      font-size: 120%;
      @media screen and (max-width: 900px) {
          font-size:80%;
        }
    }
    &-img{
      z-index: 999;
      img{
        width: 400px;
        height: 400px;
        @media screen and (max-width: 900px) {
         width: 60%;
         height: 60%;
        }
      }
    }
  }
}
.section-3-bg{
  position: absolute;
  z-index:-1;
}
.md-center{
  text-align: center;
}
.md-section{
  padding-top:3rem;
  padding-bottom: 3rem;

  img{
    height:120px;
  }
}
.cp-about-view {
  &-breadcrumbs-container {
    border-top: 1px solid $primary;
    border-bottom: 1px solid $primary;
  }

  &-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-logo {
    margin-top: 40px;
    margin-bottom: 30px;
    height: 80px;
    margin-left: auto;
    margin-right: auto;
    display: block;

    @media screen and (max-width: 768px) {
      height: 40px;
    }
  }

  &-company-image-mobile {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 50vw;
  }

  &-company-name {
    padding-bottom: 5px;
    border-bottom: 1px solid $primary;
    margin-bottom: 20px;
  }

  &-icon-set {
    margin-bottom: 0;
  }

  &-product-image {
    width: 100%;
  }
}
</style>
